const BaseUrl = "https://landpandawebapi.azurewebsites.net";
const apiUrl_dialerp = "https://dialerpinapi.azurewebsites.net";
const apiTest_Url = "https://erpinuat.azurewebsites.net";
const CRMAi_Url = "https://ivragentwebapi.azurewebsites.net";
const Appname = "LandPanda";
const subID = 10027;


let Authorization_Token = "";

const Dialerp_IN_Token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFkbWluQGRpYWxlcnAuY29tIiwic2lkIjoiMTAwMDEiLCJqdGkiOiIzMDMxYTcwOC0yMTNhLTQzZDAtYjRlZS01MDkyNTRhNzk3MDYiLCJBcHBJRCI6IjAiLCJBcHBOYW1lIjoiRGlhbEVycFdlYiIsIkxlZGdlcklEIjoiMTAwMiIsIkxlZGdlck5hbWUiOiJWaXZlayBHdXB0YSIsIkNvbXBhbnlOYW1lIjoiRElBTCBFUlAgVGVjaG5vbG9naWVzIEx0ZCIsIlRpbWV6b25lIjoiSW5kaWEgU3RhbmRhcmQgVGltZSIsIlRpbWV6b25lSUQiOiIxMDQiLCJBZGREZWR1Y3RIcnMiOiIrIiwiVXRjT2Zmc2V0IjoiMDU6MzAiLCJJc3RPZmZzZXQiOiIwMDowMCIsIlJvbGVJRCI6IjEiLCJleHAiOjE4NjEzNTEyMzMsImlzcyI6ImRpYWxlcnAuaW4iLCJhdWQiOiJkaWFsZXJwLmluIn0.eggAHhP_xjGD0qgmzwY0JXwU0Rlx_DU37FXouwTHrG8"
const staticToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJiNmZjYWI2OC1mMGVmLTRhODEtYjg1Yi02OTMwNTlhMzg0MTciLCJhdXRoX3RpbWUiOiI2MzkwMzQ2NDA5ODgxOTkyMjUiLCJtb2JpbGUiOiI4ODUxMzU0MDk5IiwiZW1haWxJRCI6Imt1c2hhZ3JrdW1hcjIwMTdAZ21haWwuY29tIiwidXNlcklEIjoiMTAwMjciLCJ1c2VyUm9sZSI6IjEiLCJhcHBJRCI6IjEiLCJwYXJlbnRJZCI6IjEwMDI3IiwiUGFydHlBY1RCU3IiOiIxIiwiVW5kZXJMZWRnZXJHcm91cElEIjoiMCIsIlRpbWV6b25lSUQiOiIwIiwiTGVkZ2VyTmFtZSI6Ikt1c2hhZ3JhIiwiQ29tcGFueU5hbWUiOiJhZG1pbiIsIkFwcE5hbWUiOiJMYW5kUGFuZGEiLCJUaW1lem9uZSI6IiIsIkFkZERlZHVjdEhycyI6IiIsIlV0Y09mZnNldCI6IiIsIklzdE9mZnNldCI6IiIsIkRldmljZVdoaXRlbGlzdElEIjoiMCIsIkRldmljZVdoaXRlbGlzdFN0YXR1c0lEIjoiMCIsImNCeUlEIjoiMSIsIkxlZGdlcklEIjoiMSIsIlN1YnNjcmliZXJJRCI6IjEwMDI3IiwiU3RhdHVzIjoiQWN0aXZlIiwiU3RhdHVzSUQiOiIyIiwiRW1haWwiOiJrdXNoYWdya3VtYXIyMDE3QGdtYWlsLmNvbSIsImVtYWlsIjoia3VzaGFncmt1bWFyMjAxN0BnbWFpbC5jb20iLCJTdWJzSUQiOiIxMDAyNyIsIlN1YmRvbWFpbiI6ImFkbWluIiwiTW9iaWxlIjoiODg1MTM1NDA5OSIsImV4cCI6MTgzMDkzOTMxMywiaXNzIjoid2hpdGViaWxscy5jb20iLCJhdWQiOiJ3aGl0ZWJpbGxzLmNvbSJ9.ipzOLoRCKeS6DhPvt-1QAYP-nmsXdsR_F2aY24dkR2U";
let LoggedInUserID = null;
let LoggedInUserName = null;
let AUTH_KEY =
  "DYllUsQO+nKLqpDZ0527kagiuHLu4qRL4hNoYHZI7yEVmjpO/tsOY3dt0CnteraeljLAg0g/0xFP/5duL012Zd1R+eGGyGLCWvXv9HUfZAg=";

function setLogindata(data) {
 // console.log("Setting login data:", data);
  Authorization_Token = data ? data.loginKey : "";
  LoggedInUserID = data ? data.partySr : null;
  // LoggedInUserName = data.userName;
}

function setUserdata(data) {
  //console.log("Setting login data:", data);
  
   LoggedInUserName = data ? data.User : null ;
}


    const  characterEncoding = "UTF-8"
    const key = "0e628f15575e4a7189ec11a50301bb70"

    const  cipherTransformation = "AES/CBC/PKCS5Padding"
    const  aesEncryptionAlgorithm = "AES"

export {
  BaseUrl,
  apiUrl_dialerp,
  apiTest_Url,CRMAi_Url,
  Appname,
  subID,
  Authorization_Token,
  staticToken,
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  setLogindata,setUserdata,characterEncoding,key,cipherTransformation,aesEncryptionAlgorithm,Dialerp_IN_Token
};
